import { render, staticRenderFns } from "./fragment-gfx3d-submit.vue?vue&type=template&id=a270cdea&scoped=true&"
import script from "./fragment-gfx3d-submit.vue?vue&type=script&lang=js&"
export * from "./fragment-gfx3d-submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a270cdea",
  null
  
)

export default component.exports